import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'input[type=number]'
})
export class PreventNumberScrollDirective {

  constructor(private readonly elementRef: ElementRef<HTMLInputElement>) { }

  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent): void {
    if (document.activeElement !== this.elementRef.nativeElement) {
      return;
    }

    event.preventDefault();
  }
}